var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 5.4H6.6V0.6C6.6 0.44087 6.53679 0.288258 6.42426 0.175736C6.31174 0.0632141 6.15913 0 6 0C5.84087 0 5.68826 0.0632141 5.57574 0.175736C5.46321 0.288258 5.4 0.44087 5.4 0.6V5.4H0.6C0.44087 5.4 0.288258 5.46321 0.175736 5.57574C0.0632141 5.68826 0 5.84087 0 6C0 6.15913 0.0632141 6.31174 0.175736 6.42426C0.288258 6.53679 0.44087 6.6 0.6 6.6H5.4V11.4C5.4 11.5591 5.46321 11.7117 5.57574 11.8243C5.68826 11.9368 5.84087 12 6 12C6.15913 12 6.31174 11.9368 6.42426 11.8243C6.53679 11.7117 6.6 11.5591 6.6 11.4V6.6H11.4C11.5591 6.6 11.7117 6.53679 11.8243 6.42426C11.9368 6.31174 12 6.15913 12 6C12 5.84087 11.9368 5.68826 11.8243 5.57574C11.7117 5.46321 11.5591 5.4 11.4 5.4",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.21a2e29a438da0611435a2ca8f0d4376.svg";
export { ForwardRef as ReactComponent };